import { combineReducers } from '@reduxjs/toolkit'
import selectedBrand from './selectedBrand'
import storiesSummaryError from './storiesSummaryError'
import selectLostShoppers from './selectLostShoppers'
import defaultSelectedLostShopper from './defaultSelectedLostShopper'
import topLostShoppers from './topLostShoppers'
import kbqTopPurchasedData from './kbqTopPurchasedData'
import kbqChartData from './kbqChartData'
import accordionPanels from './accordionPanels'
import selectedPurchaseDriversList from './selectedPurchaseDriversList'
import selectedRetailer from './selectedRetailer'
import selectedChannelVisited from './selectedChannelVisited'
import topPurchasedBrandDonut from './topPurchasedBrandDonut'
import donutViewByItems from './donutViewByItems'
import selectedDropdownMode from './selectedDropdownMode'
import topTopicsNPS from './topTopicsNPS'
import selectedTopic from './selectedTopic'
import selectedNps from './selectedNps'
import primarySuffixLabel from './primarySuffixLabel'
import summary from './storiesPageSummary'

const KBQBrands = combineReducers({
  donutViewByItems,
  selectedBrand,
  storiesSummaryError,
  selectLostShoppers,
  defaultSelectedLostShopper,
  topLostShoppers,
  kbqTopPurchasedData,
  kbqChartData,
  summary,
  accordionPanels,
  selectedPurchaseDriversList,
  selectedRetailer,
  selectedChannelVisited,
  topPurchasedBrandDonut,
  selectedDropdownMode,
  topTopicsNPS,
  selectedTopic,
  selectedNps,
  primarySuffixLabel,
})

export type KBQ = ReturnType<typeof KBQBrands>

export default KBQBrands
